
/**
 * @nullable
 */
export type ArticleMetricsModelPpmCode = typeof ArticleMetricsModelPpmCode[keyof typeof ArticleMetricsModelPpmCode] | null;


export const ArticleMetricsModelPpmCode = {
  I: 'I',
  G: 'G',
  P: 'P',
  O: 'O',
  E: 'E',
  N: 'N',
  NA: 'NA',
} as const;
